module.exports = __webpack_public_path__ + "img/рз_22.42626ec7.png";